import { Sort, SortOrder } from '../grid/experimental.grid';

import { FocusSelectorFocusForPerformer } from './focus-selector-focus-for-performer.model';
import { FocusSelectorFocusForTeam } from './focus-selector-focus-for-team.model';
import { Context, FocusSelectorGrid } from './focus-selector.grid.model';

export enum ColumnID {
    DIRECT_REPORT = 'direct_report',
    METRIC = 'metric',
    BEHAVIOUR = 'behaviour',
    TACTIC = 'tactic',
    CURRENT_IMPROVEMENT = 'current_improvement',
    DAYS_ACTIVE = 'days_active',
}

export interface FocusHistoryRowContext<
    TFocusModel extends
        | FocusSelectorFocusForPerformer
        | FocusSelectorFocusForTeam,
> extends Context {
    focus: TFocusModel;
}

export interface FocusHistoryCellContext
    extends Context,
        Partial<FocusSelectorFocusForPerformer & FocusSelectorFocusForTeam> {
    checked?: boolean;
}

export interface FocusHistoryGrid<
    TFocusModel extends
        | FocusSelectorFocusForPerformer
        | FocusSelectorFocusForTeam,
> extends FocusSelectorGrid<
        FocusHistoryRowContext<TFocusModel>,
        FocusHistoryCellContext
    > {
    selection?: {
        behaviour: string;
        behaviourId: number;
        tactic: string;
        tacticId: number;
    };
}

export const defaultPerformerSortDefs: Sort[] = [
    {
        columnId: ColumnID.DAYS_ACTIVE,
        order: SortOrder.DESC,
    },
];

export const defaultTeamSortDefs: Sort[] = [
    {
        columnId: ColumnID.DIRECT_REPORT,
        order: SortOrder.ASC,
    },
    {
        columnId: ColumnID.DAYS_ACTIVE,
        order: SortOrder.DESC,
    },
];
